/*
 * File: performance.ts
 * File Created: 2024-01-10 08:18:58
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-30 03:47:49
 * Modified By: Val Liu
 * -----
 */

import { NumberHelper } from "../utilities";

const initial = performance.now();

function _(): any {
    return (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;

        let total = 0;
        let count = 0;
        descriptor.value = function (...args: any[]) {
            const start = performance.now();
            const result = originalMethod.apply(this, args);
            const end = performance.now();
            const toFixed = (num) => NumberHelper.toFixedNumber(num, 3);

            let current = end - start;
            total += current;
            count++;
            console.log(
                `Execution time of ${_propertyKey}: ${toFixed(
                    current,
                )} ms, total: ${toFixed(total)} ms, times: ${count}. @${toFixed(
                    end - initial,
                )} ms.`,
            );
            return result;
        };

        return descriptor;
    };
}

export { _ as performance };
